import { render, staticRenderFns } from "./userData.vue?vue&type=template&id=b41f6636&scoped=true"
import script from "./userData.vue?vue&type=script&lang=js"
export * from "./userData.vue?vue&type=script&lang=js"
import style0 from "./userData.vue?vue&type=style&index=0&id=b41f6636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41f6636",
  null
  
)

export default component.exports